// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"3f73b9cf","181":"4b0c31d2","185":"ef880683","277":"55486373","365":"5bf0afbc","517":"96318f1a","544":"532087a1","659":"16f808fc","667":"ddb4cec2"}[chunkId] + ".chunk.js";
};